import './Alignment.css';
export var horizontalAlignmentCSS = {right:'_8g1j410-2-0-1',left:'_8g1j411-2-0-1',center:'_8g1j412-2-0-1'};
export var verticalAlignmentCSS = {top:'_8g1j413-2-0-1',center:'_8g1j414-2-0-1',bottom:'_8g1j415-2-0-1'};